import * as React from 'react';
import { SVGProps } from 'react';

const FileIconDocSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 34 40" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M32 0H2a2 2 0 0 0-2 2v36a2 2 0 0 0 2 2h30a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Z"
      fill="#75ADEA"
    />
    <path
      opacity={0.6}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 20h18v-1H8v1Zm0 4h18v-1H8v1Zm18 4H8v-1h18v1ZM8 32h9v-1H8v1Z"
      fill="#fff"
    />
    <path
      d="M13 11.77c-.22.153-.487.23-.8.23h-.5c-.587 0-1.017-.123-1.29-.37-.273-.253-.41-.663-.41-1.23V8.6c0-.56.137-.967.41-1.22.28-.253.77-.38 1.35-.38H13V5h1v7h-1v-.23Zm-.65-.77c.22 0 .383-.057.49-.17a.565.565 0 0 0 .16-.38V8h-1.25c-.247 0-.433.057-.56.17-.127.113-.19.273-.19.48v1.7c0 .207.063.367.19.48.127.113.313.17.56.17h.6ZM19 10.4c0 .56-.14.967-.42 1.22-.273.253-.7.38-1.28.38h-.6c-.58 0-1.01-.127-1.29-.38-.273-.253-.41-.66-.41-1.22V8.6c0-.56.137-.967.41-1.22.28-.253.71-.38 1.29-.38h.6c.58 0 1.007.127 1.28.38.28.253.42.66.42 1.22v1.8Zm-1-1.75c0-.207-.063-.367-.19-.48-.127-.113-.313-.17-.56-.17h-.5c-.247 0-.433.057-.56.17-.127.113-.19.273-.19.48v1.7c0 .207.063.367.19.48.127.113.313.17.56.17h.5c.247 0 .433-.057.56-.17.127-.113.19-.273.19-.48v-1.7ZM21.71 12c-.587 0-1.017-.123-1.29-.37-.273-.253-.41-.663-.41-1.23V8.6c0-.56.137-.967.41-1.22.28-.253.71-.38 1.29-.38H23v1h-1.25c-.247 0-.433.057-.56.17-.127.113-.19.273-.19.48v1.7c0 .207.063.367.19.48.127.113.313.17.56.17H23v1h-1.29Z"
      fill="#fff"
    />
  </svg>
);
export default FileIconDocSizeM;
